import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';
import type { BankFindInterface } from '@zaoblako/shared/modules/catalog/dtos/bank/bank-find.dto';

@Component({
  standalone: true,
  selector: 'crm-bank-auto-complete',
  templateUrl: './bank-auto-complete.component.html',
  imports: [CommonModule, AutoCompleteComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankAutoCompleteComponent {
  @Input() public selectedBank: BankFindInterface;
  @Output() public selectedBankChange = new EventEmitter<BankFindInterface>();

  @Input() public banks: BankFindInterface[] = [];
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public field = 'name';
  @Input() public appendTo: string;

  @Output() public bankSearch = new EventEmitter<string>();

  public toBank(bank: any): BankFindInterface {
    return bank as BankFindInterface;
  }
}
